<template>
  <BaseDialog centered contentClass="delete-task-template-dialog" ref="dialog" :show-actions="false">
    <template slot="title">
      {{ $t('page.admin-task-templates.delete-dialog.title') }}
    </template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div class="delete-task-template-dialog__message">
          <span>{{ $t('page.admin-task-templates.delete-dialog.are-you-sure') }}</span>
        </div>
        <div class="delete-task-template-dialog__template-name">
          {{ templateName }}
        </div>
        <div class="delete-task-template-dialog__actions">
          <FormButton is-outlined class="delete-task-template-dialog__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton @click.native="onSubmit" type="submit">
            <span>{{ $t('actions.confirm') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import { mapActions } from 'vuex';

export default {
  name: 'DeleteTaskTemplateDialog',
  components: {
    FormButton,
    BaseDialog,
  },
  data() {
    return {
      templateId: null,
      templateName: '',
    };
  },
  methods: {
    ...mapActions('taskTemplates', ['deleteTaskTemplate']),
    openDialog(template) {
      this.templateId = template.id;
      this.templateName = template.title;
      this.$nextTick(() => {
        this.$refs.dialog.openModal();
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      this.deleteTaskTemplate(this.templateId)
        .then(() => {
          this.$toast.success(this.$t('page.admin-task-templates.actions.success-delete'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch(() => {
          this.$toast.error(this.$t('errors.genericError'));
        });
    },
    cancelClick() {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-task-template-dialog {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.delete-task-template-dialog {
  &__message {
    color: $color-normal;
    margin-bottom: 16px;
  }

  &__template-name {
    font-weight: 700;
    color: $color-normal;
    padding: 12px 16px;
    background: $color-neutral-pale;
    border-radius: $border-radius-root;
  }

  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
